module.exports = __webpack_public_path__ + "img/estrellas-background.3a463be7.png";